<template>
  <div class="toastification">
    <div class="d-flex align-items-start">
      <b-avatar
        :variant="variant"
        size="1.8rem"
        class="mr-75 flex-shrink-0"
      >
        <feather-icon
          :icon="icon"
          size="15"
        />
      </b-avatar>
      <div class="d-flex flex-grow-1">
        <div>
          <h5
            v-if="title"
            class="mb-0 font-weight-bolder toastification-title"
            :class="`text-${variant}`"
            v-text="title"
          />
          <small
            v-if="text"
            class="d-inline-block text-body"
            v-text="text"
          />
          <div 
            class="d-flex justify-content-end"
            v-if="button"
          >
          <b-button
            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
            :variant="buttonVariant"
            @click="buttonOnClick(); $emit('close-toast');"
          >
            {{ buttonText }}
          </b-button>

          </div>
        </div>
        <span
          class="cursor-pointer toastification-close-icon ml-auto "
          @click="$emit('close-toast'); onCloseClick()"
        >
          <feather-icon
            v-if="!hideClose"
            icon="XIcon"
            class="text-body"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar, BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BAvatar,
    BButton,
  },
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    icon: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
    button: {
      type: Boolean,
      default: false
    },
    buttonVariant: {
      type: String,
      default: 'success'
    },
    buttonText: {
      type: String,
      default: 'OK'
    },
    buttonOnClick: {
      type: Function,
      default: () => {}
    },
    onCloseClick: {
      type: Function,
      default: () => {}
    }
  },
  directives: {
    Ripple
  }
}
</script>

<style lang="scss" scoped>
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}

.toastification-title {
  color: inherit;
}
</style>
